module.exports = require('./helpers/bundle-url').getBundleURL('3eKgh') + "logo-dark.eefe0b7f.svg";